<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" style="font-size:35px" @click="goback"></div>
      </div>
      <div class="header">投票详情</div>
      <div class="newvote">
        <Button  @click="download">导出</Button>
        <Button class="btn-dc" type="primary" @click="goFabu">编辑</Button>
      </div>
    </div>
    <div class="content">
      <Card>
        <div class="content-top">
          <div class="vote-detail">
            <Form :model="detailItem" :label-width="80">
              <FormItem label="投票标题">
                <p class="detail">{{detailItem.title}}</p>
              </FormItem>
              <FormItem label="截止时间">
                <p class="detail">{{detailItem.endTime}}</p>
              </FormItem>
              <FormItem label="投票详情">
                <div class="add-con" @click="openContent">
                  <span :class="showContent?'con-open' : ''">查看详情</span>
                  <i
                    class="iconfont"
                    :class="showContent ? 'icon--icon_arrow_up' : 'icon-xiala'"
                  ></i>
                </div>
                <div class="vote-con" v-if="showContent" v-html="detailItem.context"></div>
              </FormItem>
              <FormItem label="权限设置">
                <p class="detail">{{detailItem.joinUserType}}</p>
              </FormItem>
              <FormItem label="隐私设置">
                <p class="detail">投票{{detailItem.visibleAppType}}</p>
              </FormItem>
              <FormItem label="发布至">
                <p class="detail">{{detailItem.miniShequ}}</p>
              </FormItem>
              <FormItem label="置顶">
                <p class="detail">{{detailItem.isTop}}</p>
              </FormItem>
            </Form>
          </div>
        </div>
        <div class="vote-select">
          <Form :model="selectItem" :label-width="80">
            <FormItem label="投票方式">
              <div class="detail">{{selectItem.xuanxiang}}</div>
            </FormItem>
            <FormItem label="选项" id="selectoption">
              <div class="sel-wrap" v-for="(item, index) in selectItem.options" :key="index">
                <p>选项{{index + 1}}</p>
                <div class="box" style="height: 64px">
                  <div class="box box_f1">
                    <img :src="item.pic" class="box sel-pic" v-if="item.pic" alt />
                    <span class="box_f1 sel-title slh" nowrap>{{item.title}}</span>
                  </div>
                  <div class="box box_f1" style="width: 615px">
                    <div class="box sel-per">
                      <div class="percent" :style="{width: item.percent + '%'}"></div>
                    </div>
                    <div
                      class="box_f1"
                      style="width: 100px;line-height: 64px"
                    >{{item.userCount}}人&nbsp;&nbsp;{{item.percent}}%</div>
                  </div>
                </div>
                <Tabs :animated="false">
                  <TabPane label="投票人">
                    <div class="person" v-for="(_item,index) in item.userList" :key="index">
                      <img :src="_item.pic" alt />
                      <p class="slh">{{_item.name}}</p>
                    </div>
                  </TabPane>
                  <TabPane label="查看详情">
                    <div class="sel-con" v-html="item.context == '' ? '本选项无详情': item.context"></div>
                  </TabPane>
                </Tabs>
              </div>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailItem: {},
      showContent: false,
      selectItem: {}
    };
  },
  methods: {
    download(){
      window.open(
        `${this.urlobj.voteExport}?voteId=${this.$route.query.id}&token=${this.$store.state.access_token}`
      );
    },
    openContent() {
      this.showContent = !this.showContent;
    },
    getDetail() {
      var url = this.urlobj.voteDetail(this.$route.query.id);
      this.$get(url).then(res => {
        var resData = res.rows[0];
        console.log(resData.endTime.substr(0, resData.endTime.length - 2).split(' '))
        var shequ = resData.zoneList.map(item => {
          return  item.zoneName
        })
        this.detailItem = {
          title: resData.title,
          endTime: resData.endTime.substr(0, resData.endTime.length - 2),
          context: resData.context == "" ? "本投票无详情" : resData.context,
          isTop: resData.isTop == 1 ? "已置顶" : "未置顶",
          joinUserType:
            resData.joinUserType == ""
              ? "所有人可参与"
              : "仅实名认证用户可参与",
          visibleAppType:
            resData.visibleAppType == "" ? "所有人可见" : "仅社工可见",
          miniShequ: shequ.join(',')
        };
        this.selectItem.xuanxiang = resData.isRadio == 1 ? "单选" : "多选";
      });
    },
    //获取选项详情
    getSelDetail() {
      var url = this.urlobj.optionDetail(this.$route.query.id);
      this.$get(url).then(res => {
        var list = res.rows.map(item => {
          return {
            title: item.message,
            userCount: item.userCount,
            percent: item.percentage,
            pic: item.headPicUrl
          };
        });
        var idList = res.rows.map(item => {
          return item.id;
        });
        // console.log(list, idList);
        idList.forEach((item, index) => {
          var data1 = {
            pageNum: 0,
            pageSize: 0
          };
          this.$get(this.urlobj.selPerson(item), data1).then(res => {
            list[index].userList = res.rows.map(item1 => {
              return {
                name: item1.realName ? item1.realName : item1.userName,
                pic: item1.headPicUrl
              };
            });
            var data2 = {
              comeId: item,
              comeType: 71
            };
            this.$get(this.urlobj.selDetail, data2).then(res => {
              list[index].context = res.newPrimaryKeys.context;
              console.log(list);
              this.selectItem.options = list;
              this.$forceUpdate()
            });
          });
        });
      });
    },
    goback(){
        this.$router.push({name: 'votelist'})
    },
    goFabu(){
        this.$router.push({name: 'newVote', query:{id: this.$route.query.id}})
    }
  },
  created() {},
  mounted() {
    this.getDetail();
    this.getSelDetail();
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.header {
  font-size: 25px;
  text-align: center;
}
.newvote {
  position: absolute;
  right: 20px;
  button {
    width: 80px;
    height: 28px;
    line-height: 13px;
  }
  .btn-dc {
    background-color: #ff7c43;
    border-color: #ff7c43;
    margin-left: 10px;
  }
}
.content {
  // max-width: 96%;
  margin: 20px;
}
.add-con {
  font-size: 16px;
  color: #999;
  width: 110px;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
}
.cha {
  display: inline-block;
  margin-left: 10px;
  width: 0;
  color: #d42b2b;
}
.vote-detail {
  width: 850px;
  margin: 0 auto;
}
.vote-select {
  width: 850px;
  margin: 0 auto;
  margin-top: 20px;
}
.content-top {
  border-bottom: 1px solid #ddd;
}
.icon-xuanzhong1 {
  color: #fe7d43;
}
/deep/ .ivu-input {
  font-size: 16px;
}
/deep/ .ivu-form-item-label {
  font-size: 16px;
//   margin-right: 20px;
}
/deep/ .ivu-radio-wrapper {
  font-size: 16px;
  color: #999;
}
/deep/ #selectoption {
    margin-right: 0;
}
.sel-dea {
  border: 1px solid #ddd;
  border-radius: 2px;
  padding: 10px;
  width: 510px;
}
.del {
  margin: auto;
  margin-left: 10px;
  color: #d42b2b;
}
.add-con1 {
  font-size: 16px;
  color: #ff7c43;
  border: 1px solid #ff7c43;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  padding: 0 5px;
  margin-top: 20px;
}
.nosel {
  font-size: 16px;
  color: #999;
}
.detail {
  font-size: 16px;
  color: #999;
}
.con-open {
  font-size: 16px;
  color: #fe9266;
}
.vote-con {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 20px;
  margin-left: 20px;
  font-size: 14px;
}
.sel-pic {
  height: 64px;
  width: 54px;
}
.sel-title {
  width: 220px;
  padding: 10px;
  line-height: 44px;
  height: 64px;
  font-size: 14px;
  color: #999;
}
.sel-per {
  width: 430px;
  margin-right: 10px;
}
.percent {
  height: 6px;
  border-radius: 3px;
  background: #fe7d43;
  width: 50%;
  margin: auto 0;
}
.person {
  width: 60px;
  height: 90px;
  text-align: center;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  img {
    width: 54px;
    height: 54px;
    border-radius: 50%;
  }
  p {
    font-size: 14px;
    color: #999;
    margin-top: -10px;
  }
}
.sel-con {
  padding: 10px;
  border: 1px solid #dddddd;
  width: 100%;
  height: 100%;
  font-size: 14px;
}
.sel-wrap {
  border-bottom: 1px solid #ddd;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.vote-con img{
  width: 100%;
  height: 100%;
}
</style>

